import axios from "axios";
import {FORGOT_PASSWORD_URL, RESET_PASSWORD_URL} from "../api";

// Request a 6-digit reset code to be emailed to the user.
export const forgotPassword = async (email) => {
    try {
        const response = await axios.post(FORGOT_PASSWORD_URL, {email});
        return {error: false, payload: response.data?.message || "A reset code has been sent."};
    } catch (error) {
        return {
            error: true,
            payload: error.response?.data?.errors?.[0]
                || error.response?.data?.message
                || "Failed to send reset code",
        };
    }
};

// Exchange the emailed code for a new password.
export const resetPassword = async ({email, code, newPassword}) => {
    try {
        const response = await axios.post(RESET_PASSWORD_URL, {email, code, newPassword});
        return {error: false, payload: response.data?.message || "Password was changed successfully."};
    } catch (error) {
        return {
            error: true,
            payload: error.response?.data?.errors?.[0]
                || error.response?.data?.message
                || "Failed to reset password",
        };
    }
};
